import React from 'react';
import { BaseEdge, getBezierPath, type EdgeProps } from '@xyflow/react';

/**
 * A permanent bond edge between a generate node and its variation nodes.
 * Cannot be deleted — no delete button shown even when selected.
 * Visually distinct: dashed amber stroke.
 */
export function VariationEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  markerEnd,
  data,
}: EdgeProps) {
  // Check if this edge is connected to a selected node
  const isHighlighted = data?.highlighted === true;

  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <g style={{ zIndex: isHighlighted ? 1000 : 0 }}>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          stroke: isHighlighted ? '#3b82f6' : '#f59e0b', // Blue when highlighted
          strokeWidth: isHighlighted ? 3 : 2,
          strokeDasharray: '6 3',
        }}
      />
    </g>
  );
}
